var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPersonalIncentive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F2FBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#A6E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.5013H18.1667V11.168C18.1667 10.6213 17.7133 10.168 17.1667 10.168C16.62 10.168 16.1667 10.6213 16.1667 11.168V14.5013H15.8333C13.7133 14.5013 12.5 15.7146 12.5 17.8346V25.8346C12.5 27.9546 13.7133 29.168 15.8333 29.168H16.1667V37.8346C16.1667 38.3813 16.62 38.8346 17.1667 38.8346C17.7133 38.8346 18.1667 38.3813 18.1667 37.8346V29.168H18.5C20.62 29.168 21.8333 27.9546 21.8333 25.8346V17.8346C21.8333 15.7146 20.62 14.5013 18.5 14.5013Z",
    fill: "#2D96BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1641 19.8346H32.8307V11.168C32.8307 10.6213 32.3774 10.168 31.8307 10.168C31.2841 10.168 30.8307 10.6213 30.8307 11.168V19.8346H30.4974C28.3774 19.8346 27.1641 21.048 27.1641 23.168V31.168C27.1641 33.288 28.3774 34.5013 30.4974 34.5013H30.8307V37.8346C30.8307 38.3813 31.2841 38.8346 31.8307 38.8346C32.3774 38.8346 32.8307 38.3813 32.8307 37.8346V34.5013H33.1641C35.2841 34.5013 36.4974 33.288 36.4974 31.168V23.168C36.4974 21.048 35.2841 19.8346 33.1641 19.8346Z",
    fill: "#07506D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonalIncentive);
export default __webpack_public_path__ + "static/media/ic-personal-incentive.6131422a7b3775918fa77dd56ffa92ac.svg";
export { ForwardRef as ReactComponent };